export default __webpack_public_path__ + "static/media/banner.dbfcbc06.jpg";